
// *************************** Import CSS *************************** //

import '@styles/main.scss';
import "./nav-header-footer.css";

// **************** Function Spinner Show & Hide ******************** //

  function spinnerShow() {
      document.getElementById("function-spinner").style.display = "block";
  }

  function spinnerHide() {
      document.getElementById("function-spinner").style.display = "none";
  }

// *********************************************** Insert Top Navigation Menu ************************************************ //

class FirstNav extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

    <section id="nav-section" class="nav-section sticky-nav">

      <div class="container-fluid container-xl d-flex justify-content-center align-items-center px-0">

        <div class="nav-container container d-flex justify-content-center px-0 mx-auto">

          <!-- ************************ BEGIN: Top Nav Row ************************ -->
      
          <div id="primary-nav" class="row col-12 d-flex justify-content-around align-items-center mx-auto">
      
            <div class="logo-div col-3 py-1 ps-1 ps-sm-2 ps-xl-0">
              <a href="/" class="d-inline-block">
                <img class="navbar-logo" src="assets/logos/gcs-pink-logo-2026-glossy.png" height="100px" alt="Girls Code Savannah logo" />
              </a>
            </div>
      
            <div class="wordmark-div col-7 col-md-6 d-flex justify-content-center">
              <a href="/" class="d-flex align-items-center text-decoration-none">
                <img class="navbar-wordmark" src="assets/logos/gcs-wordmark-2026-glossy.webp" height="49px" width="168px" alt="Girls Code Savannah wordmark" />
              </a>
              <span class="d-none">Girls Code Savannah</span>
            </div>
      
            <div id="login-btn-top" class="login-btn-top col-2 col-md-3 d-flex justify-content-center d-none d-xl-block">
              <a href="/login" class="bold btn slide-hover-button">LOG IN</a>
            </div>

            <!-- Toggle Button for Mobile Nav -->

            <div id="nav-toggle" class="nav-toggle-div col-2 col-md-3 d-flex justify-content-end d-xl-none pe-2 pe-md-3">
              <button class="navbar-toggler-btn collapsed d-flex flex-column justify-content-around"
                type="button" data-bs-toggle="collapse" data-bs-target="#navbar-items"
                aria-controls="navbar-items" aria-expanded="false" aria-label="Toggle navigation">
                <span class="toggler-bars top-bar"></span>
                <span class="toggler-bars middle-bar"></span>
                <span class="toggler-bars bottom-bar"></span>
              </button>
            </div>

          </div> <!-- primary nav -->

          <!-- ************************ END: Top Nav Row ************************ -->

        </div> <!-- container -->

      </div> <!-- container-fluid -->


        <!-- *********************** BEGIN: Bottom Nav Row ************************  -->

        <div id="secondary-nav" class="container-fluid container-xl px-0">

          <nav class="navbar navbar-expand-xl p-0" aria-label="Navigation" role="navigation">

            <div id="navbar-items" class="collapse navbar-collapse">

              <ul class="navbar-nav w-100 d-flex justify-content-between align-items-center">

                <li class="nav-item nav-home">
                  <a class="nav-link font-oswald bold letter-spacing-1px" href="/">Home</a>
                </li>

                <li class="nav-item nav-campclass">
                  <a id="nav-cc-link" class="nav-link font-oswald bold letter-spacing-1px" href="/camps-classes">Camps & Classes</a>
                </li>

                <li class="nav-item nav-instructors">
                  <a class="nav-link large-screen-nav font-oswald bold letter-spacing-1px" href="/instructors">Instructors</a>
                </li>

                <li class="nav-item nav-faqs">
                  <a class="nav-link font-oswald bold letter-spacing-1px" href="/faqs">FAQs</a>
                </li>

                <li class="nav-item nav-about">
                  <a class="nav-link font-oswald bold letter-spacing-1px" href="/about">About &#38; Press</a>
                </li>

                <li class="nav-item nav-contact">
                  <a class="nav-link font-oswald bold letter-spacing-1px" href="/contact">Contact</a>
                </li>

                <li class="nav-item nav-donate">
                  <a class="nav-link font-oswald bold letter-spacing-1px" href="/donate">Donate</a>
                </li>

                <li class="nav-item nav-websites">
                  <a class="nav-link font-oswald bold letter-spacing-1px" href="/student-websites">Student Websites</a>
                </li>

                <!-- <li class="nav-item nav-websites">
                  <a class="nav-link font-oswald bold letter-spacing-1px" href="/student-gallery">Student Gallery</a>
                </li> -->

                <!-- MY PAGE -->
                <!-- <li id="my-page-nav-link" class="nav-item hidden">
                  <a class="nav-link bold" href="/my-page">My Page</a>
                </li> -->

                <!-- LOG IN BUTTON -->
                <li id="login-btn-bottom-row" class="login-btn-toggle nav-item mx-auto mt-1 d-lg-none">
                  <a href="/login" class="nav-link-auth bold btn btn-primary">LOG IN</a>
                </li>

                <!-- LOG OUT BUTTON -->
                <!-- <li id="logout-nav-button" class="nav-item mx-auto me-lg-3 mt-1 hidden">
                  <a href="#" class="nav-link-auth bold btn btn-primary">LOG OUT</a>
                </li> -->

                <!-- <li class="nav-item mx-auto ms-lg-1 me-lg-2 pt-2 pt-lg-0">
                  <a href="https://www.facebook.com/yourdogsbest" target="_blank">
                    <img src="facebook-icon.svg" width="30" height="30" class="Facebook icon" alt="Facebook icon">
                  </a>
                </li> -->

                <!-- <li class="nav-item mx-auto ms-lg-1 me-lg-2 pt-4 pt-lg-0">
                  <a href="https://www.instagram.com/_getfoiled.pretty/" target="_blank">
                    <img src="instagram-icon.svg" width="30" height="30" class="img" alt="Instagram icon">
                  </a>
                </li> -->

              </ul>

        </nav> <!-- navbar -->

      </div> <!-- secondary-nav -->

      <!-- *********************** END: Bottom Nav Row ************************  -->

    </section>

    `
  }
}

// ************************************************ Insert Lesli Contact Info *********************************************************** //

class LesliContact extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

      <a class="text-purple bold" 
      href=mailto:lesli@girlscodesavannah.org?subject=Inquiry%20From%20Girls%20Code%20Savannah%20Website>lesli@girlscodesavannah.org.</a>
    `
  }
}

// ******************************************* Email New Camps & Classes Contact Form *********************************************************** //

class ContactForNewClasses extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

  <div class="container">

    <!-- BEGIN: Title Section -->

    <div class="row">

      <div class="col-10 mx-auto text-center">
        
        <p class="serif-heading bold mx-auto text-center text-size-h1 text-white mt-1">
          Get Notified About Our New Camps & Classes
        </p>

      </div>

    </div>

    <!-- END: Title Section -->

    <form id="signup-google-sheet" action="" name="signup-google-sheet">

      <div class="row col-12 col-sm-8 col-md-12 col-xl-10 mx-auto">

        <div class="col-10 col-md-4 col-lg-3 mb-3 mb-lg-0 mx-auto">
          <input class="form-control me-auto" type="text" id="firstName" name="firstName" placeholder="First Name" aria-label="Enter first name">
        </div>

        <div class="col-10 col-md-4 col-lg-3 mb-3 mb-lg-0 mx-auto">
          <input class="form-control me-auto" type="text" id="lastName" name="lastName" placeholder="Last Name" aria-label="Enter last name">
        </div>

        <div class="col-10 col-md-4 col-lg-3 mb-3 mb-lg-0 mx-auto">
          <input class="form-control me-auto" type="email" id="email" name="email" placeholder="Email Address" aria-label="Enter email address">
        </div>

        <div class="col-10 col-md-2 col-lg-2 text-center mx-auto">
          <button type="submit" id="email-submit-button" class="email-submit-button bg-purple">
            <span id="submit-text">Submit</span>
          </button>
        </div>

      </div>

    </form>

  </div>

    `
  }
}

// ************************************************* Insert Footer ***************************************** //

class Footer extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

  <div class="container">

  <footer class="row col-12 col-xl-11 justify-content-center mx-auto pt-1 mt-1" role="contentinfo">

    <!-- BEGIN: GCS Wordmark & Gender-Inclusive Language -->
    
    <div class="col-12 col-xl-4 mb-0">

      <a href="/">
        <img class="footer-wordmark-img mx-auto mx-xl-0" height="40px" src="assets/logos/gcs-wordmark-2026-glossy.webp" alt="Girls Code Savannah wordmark">
      </a>

      <div class="mission-text-div col-9 col-sm-10 col-md-9 col-lg-8 col-xl-10 mx-auto mx-xl-0">

        <p class="mission-text mt-1 pt-2 mb-xs-0 mb-md-2 text-xl-start text-size-h5 text-dark-blue ps-0">
          While our primary mission is to increase the participation of girls and women in STEM&#8209;based fields, 
          Girls Code Savannah welcomes all genders to attend our girl&#8209;focused camps and classes.
        </p>

      </div>

    </div>

    <!-- END: GCS Wordmark & Gender-Inclusive Language -->


    <!-- BEGIN: Footer Links -->

    <div class="col-12 col-md-4 col-xl-3 mt-xs-1 mt-md-2 mb-0">
      <p class="footer-heading serif-heading text-dark-blue mb-0 pb-1">Camps &#38; Classes Logins</p>
      <ul class="nav flex-column">
        <li class="nav-item mb-0"><a href="/beginner-students" class="nav-link footer-heading bold p-0 pt-md-1 text-body-secondary">Beginner Students</a></li>
        <li class="nav-item mb-0 mb-md-2"><a href="/returning-students" class="nav-link footer-heading bold p-0 pt-md-1 text-body-secondary">Returning Students</a></li>
      </ul>
    </div>

    <div class="col-12 col-md-4 col-xl-3 mt-2 mb-0">
      <p class="footer-heading serif-heading text-dark-blue mb-0 pb-1">Student-Built Websites</p>
      <ul class="nav flex-column">
        <li class="nav-item mb-0"><a href="https://www.foiledpretty.com" class="nav-link footer-heading bold p-0 pt-md-1 text-body-secondary" target="_blank">FoiledPretty.com</a></li>
        <li class="nav-item mb-0"><a href="https://www.savyouthmentoring.org" class="nav-link footer-heading bold p-0 pt-md-1 text-body-secondary" target="_blank">SAVYouthMentoring.org</a></li>
        <li class="nav-item mb-0 mb-md-2"><a href="/student-websites" class="nav-link footer-heading bold p-0 pt-md-1 text-body-secondary">Student Websites</a></li>
      </ul>
    </div>

    <div class="col-12 col-md-4 col-xl-2 mt-2 mb-0">
      <p class="footer-heading serif-heading text-dark-blue mb-0 pb-1">Legal</p>
      <ul class="nav flex-column">
        <li class="nav-item mb-0"><a href="/code-of-conduct" class="nav-link footer-heading bold p-0 pt-md-1 text-body-secondary">Code of Conduct</a></li>
        <li class="nav-item mb-0"><a href="/privacy-policy" class="nav-link footer-heading bold p-0 pt-md-1 text-body-secondary">Privacy Policy</a></li>
        <li class="nav-item mb-0"><a href="/terms-of-service" class="nav-link footer-heading bold p-0 pt-1 text-body-secondary">Terms of Service</a></li>
        <li class="nav-item mb-0 mb-md-2"><a href="/accessibility" class="nav-link footer-heading bold p-0 pt-1 text-body-secondary">Accessibility Statement</a></li>
      </ul>
    </div>

    <!-- END: Footer Links -->


    <!-- BEGIN: Copyright, 501c(3), & Socials -->

    <div class="d-flex flex-column flex-md-row border-top">

      <!-- Copyright -->
      <div class="col-12 col-md-3 col-lg-3 mt-2 mb-0 mb-md-1">
        <p class="copyright text-size-h5 text-dark-blue">&copy; 2023-<span class="currentYear">2025</span> Girls Code Savannah, Inc.</p>
      </div>

      <!-- 501(c)3 -->
      <div class="col-12 col-md-7 col-lg-7 mt-0 mt-md-2 mb-xl-1"> 
        <p class="text-size-h5 text-dark-blue mb-1">Girls Code Savannah is a registered 501(c)3.</p>
        <p class="text-size-h5 text-dark-blue">EIN: 99-2260202</p>
      </div>

      <!-- BEGIN: Social -->

      <div class="col-12 col-md-2 col-lg-2 mt-2 mb-1 justify-content-center mx-auto">

        <ul class="col-4 col-md-12 col-xl-8 list-unstyled d-flex mx-auto">

          <li class="social-icon-1 mx-auto">
            <a href="https://www.instagram.com/girlscodesavannah" target="_blank">
              <img height="24px" src="assets/social-icons/ig-icon-square.png" alt="Girls Code Savannah Instagram link">
            </a>
          </li>
          
          <li class="social-icon-2 mx-auto">
            <a href="https://www.linkedin.com/company/girlscodesavannah" target="_blank">
              <img height="24px" src="assets/social-icons/li-icon-square.png" alt="Girls Code Savannah LinkedIn link">
            </a>
          </li>

        </ul>

      </div>

      <!-- END: Social -->

    </div>

    <!-- END: Copyright, 501c(3), & Socials -->


  </footer>

</div>

    `
  }
}

// *********************** Define 'extends HTMLElements' Above *********************** //

customElements.define('first-nav', FirstNav);
customElements.define('lesli-contact', LesliContact);
customElements.define('email-contact-new-classes', ContactForNewClasses);
customElements.define('footer-nav', Footer);


// *********************** Calculate Navigation Bar Height *********************** //

// const navHeight = document.querySelector('.nav-section').offsetHeight;
// console.log("NavBar Height is: ", navHeight);

// *********************** Automatically Update Copyright Year *********************** //

const yearSpan = document.querySelector(".currentYear");
const currentYear = new Date();
yearSpan.innerText = currentYear.getFullYear();

const ccLink = document.getElementById("nav-cc-link");


// *********************** Highlight Active Links on Top Navigation *********************** //

//*** For Links When Changes Pages After First Load ***/

document.querySelectorAll(".nav-link").forEach((link) => {
  
  if (link.href === window.location.href) {
    link.classList.add("active");
    link.setAttribute("aria-current", "page");
  }

  if (window.location.href === 'http://localhost:9090/previous-camps-classes') {
    ccLink.classList.add("active");
    ccLink.setAttribute("aria-current", "page");
  }

  if (window.location.href === 'https://girlscodesavannah.org/previous-camps-classes') {
    ccLink.classList.add("active");
    ccLink.setAttribute("aria-current", "page");
  }

  if (window.location.href === 'http://localhost:9090/upcoming-camps-classes') {
    ccLink.classList.add("active");
    ccLink.setAttribute("aria-current", "page");
  }

  if (window.location.href === 'https://girlscodesavannah.org/upcoming-camps-classes') {
    ccLink.classList.add("active");
    ccLink.setAttribute("aria-current", "page");
  }

});

//*** For Home Link On First Load ***/

document.addEventListener("DOMContentLoaded", () => {

  const currentPath = window.location.pathname;
  const navLinks = document.querySelectorAll(".nav-link");

  navLinks.forEach(link => {
    // Check if the link's href matches the current path
    // This handles both "/" and "/" for Home
    if (link.getAttribute('href') === currentPath || 
        (currentPath === "/" && link.getAttribute('href') === "/")) {
      link.classList.add('active');
    }
  });

  // ********************* COOKIE CONSENT **************************** //

  const cookieConsent = localStorage.getItem("gcs_cookie_consent");

  // 1. If consent was already granted, activate Google Analytics immediately
  if (cookieConsent === "accepted") {
    grantGoogleConsent();
    return;
  }
  
  // 2. If already declined, do nothing (keep tracking blocked)
  if (cookieConsent === "declined") {
    return;
  }

  // 3. If no preference exists, build and show the banner after 1 second
  setTimeout(buildAndShowBanner, 1000);

  function buildAndShowBanner() {
    const banner = document.createElement("div");
    banner.id = "cookie-consent-banner";
    banner.className = "p-4 alert dismissible fade show";
    banner.setAttribute("role", "alert");

    banner.innerHTML = `
      <div class="row d-flex align-items-start">

        <div class="row me-3">
          <div class="col-1">
            <svg xmlns="http://w3.org" width="32" height="32" fill="#4A148C" class="bi bi-cookie" viewBox="0 0 16 16">
              <path d="M6 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-4-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2L9.2 4.4a.5.5 0 0 0 .2-.4A5 5 0 1 1 1 8a5 5 0 0 1 5-5 1 1 0 0 0 .8.4L8 5zm0-4a6 6 0 1 0 0 12A6 6 0 0 0 8 1"/>
            </svg>
          </div>
          <div class="col-10">
            <h5 class="fw-bold pt-1 cookie-banner-title">Cookie Settings</h5>
          </div>
        </div>

        <div>
          <p class="small text-muted mt-1 mb-3">
            We use cookies to optimize your viewing experience and analyze website traffic. By clicking "Accept All", you agree to our use of cookies. Read our <a href="/privacy-policy" class="cookie-link">Privacy Policy</a> to learn more.
          </p>
        </div>

        <div class="d-flex gap-2 justify-content-start">
          <button id="btn-accept-cookies" class="btn btn-sm btn-gcs-primary px-3 py-2 fw-semibold">Accept All</button>
          <button id="btn-decline-cookies" class="btn btn-sm btn-gcs-secondary px-3 py-2 fw-semibold">Decline</button>
        </div>

      </div>
    `;

    // Inject banner into the document
    document.body.appendChild(banner);

    // Bind event behaviors
    document.getElementById("btn-accept-cookies").addEventListener("click", function () {
      localStorage.setItem("gcs_cookie_consent", "accepted");
      grantGoogleConsent();
      banner.remove();
    });

    document.getElementById("btn-decline-cookies").addEventListener("click", function () {
      localStorage.setItem("gcs_cookie_consent", "declined");
      banner.remove();
    });
  }

  function grantGoogleConsent() {
    if (typeof gtag === "function") {
      gtag('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted'
      });
    }
  }

});
